import Vue from 'vue';


export default {
  state: {},
  actions: {
    // 新人入门主题列表
    themeClientInfo(ctx, params){
      return Vue.http.post('/client/beginnerUsed/theme-client-info', params)
    },
    // 新人入门内容列表
    beginnerInfoClientInfo(ctx, params){
      return Vue.http.post('/client/beginnerUsed/beginnerInfo-client-info', params)
    },
    // 新人入门内容详细信息
    beginnerInfoClientDetails(ctx, params){
      return Vue.http.post('/client/beginnerUsed/beginnerInfo-client-details', params)
    },
    // 新人入门内容反馈
    beginnerInfoClientFeedback(ctx, params){
      return Vue.http.post('/client/beginnerUsed/beginnerInfo-client-feedback', params)
    }
  },
  mutations: {},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/beginnerUsed.js